<script setup lang="ts">
import { AppMessageBox, AppSvgIcon } from '@libs/ui';

interface PaxSelectorMessagesProps {
  hasUserMadeAction: boolean;
  shouldShowTicketsWarning: boolean;
  shouldShowRoomSelectionWarning: boolean;
}

const props = defineProps<PaxSelectorMessagesProps>();
</script>

<template>
  <AppMessageBox
    v-if="props.shouldShowTicketsWarning && hasUserMadeAction"
    class="message-box"
    :text="$t('planner.pax.tickets_have_not_updated')"
  >
    <template #left-icon>
      <AppSvgIcon name="infoCircle" color="color-secondary-40" />
    </template>
  </AppMessageBox>
  <AppMessageBox
    v-if="props.shouldShowRoomSelectionWarning && hasUserMadeAction"
    class="message-box"
    :text="$t('planner.pax.rooms_have_not_updated')"
  >
    <template #left-icon>
      <AppSvgIcon name="infoCircle" color="color-secondary-40" />
    </template>
  </AppMessageBox>
</template>

<style scoped lang="scss">
.message-box {
  margin-bottom: var(--spacing-24);
  justify-content: flex-start;
}
</style>
